import {
  NodePreloadRulePayload,
  PreloaderRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { NodeType } from 'common/builder/constants/NodeType'
import { INode } from 'common/builder/nodes/nodeInterfaces'
import * as groupActions from 'common/groups/actions/groupsActions'
import * as sequenceActions from 'common/sequences/actions/sequenceActions'
import * as botSettingsActions from 'common/settings/actions/botSettingsActions'
import { TagsActions } from 'common/tags/store'
import { zapierActions } from 'common/zapier/redux'

/**
 * Loads required data for action group node
 */
export const ActionGroupRequiredNodeGenericPreloaderRule: PreloaderRule<
  INode,
  NodePreloadRulePayload
> = {
  predicate: (entity: INode) => entity?.nodeType === NodeType.ACTION_GROUP,

  getKey: () => 'action_group_depencency_data',

  createLoader:
    (_, { dispatch }) =>
    () =>
      Promise.all([
        dispatch(TagsActions.getListFx()),
        dispatch(sequenceActions.loadSequenceNamesList()),
        dispatch(botSettingsActions.fetchBotSettings()),
        dispatch(groupActions.fetchGroupsList()),
        dispatch(zapierActions.fetchZaps()),
      ])
        .then(() => true)
        .catch(() => false),
}
